module.exports = __webpack_public_path__ + "assets/google-sheet-listview-icon.6e1be461.svg";